import { FC, PropsWithChildren } from "react";
import styled, { css } from "styled-components";

import Text from "@/components/Text";

const Svg = styled.svg`
  margin-right: 4px;
  flex-shrink: 0;
`;

const Wrap = styled.div<{ $type: "error" | "warning" }>`
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding: 8px 16px;
  ${({ theme, $type }) => css`
    background: ${$type === "error"
      ? theme.colors.errorLight
      : theme.colors.warningLight};

    ${Svg} {
      color: ${$type === "error" ? theme.colors.error : theme.colors.warning};
    }
  `}
`;

interface Props {
  type?: "error" | "warning";
  className?: string;
}

const ValidationMessage: FC<PropsWithChildren<Props>> = ({
  children,
  type = "error",
  className,
}) => {
  return (
    <Wrap $type={type} className={className}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_204_15618"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          x="1"
          y="1"
          width="14"
          height="14"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00016 1.33334C4.32016 1.33334 1.3335 4.32 1.3335 8C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8C14.6668 4.32 11.6802 1.33334 8.00016 1.33334ZM8.00016 8.66667C7.6335 8.66667 7.3335 8.36667 7.3335 8V5.33334C7.3335 4.96667 7.6335 4.66667 8.00016 4.66667C8.36683 4.66667 8.66683 4.96667 8.66683 5.33334V8C8.66683 8.36667 8.36683 8.66667 8.00016 8.66667ZM7.3335 10V11.3333H8.66683V10H7.3335Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_204_15618)">
          <rect width="16" height="16" fill="currentColor" />
        </g>
      </Svg>
      <Text as="span" $type="smallBold">
        {children}
      </Text>
    </Wrap>
  );
};

export default ValidationMessage;
